import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

import user from './modules/user'
import expert from './modules/expert'
import permission from './modules/permission'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    expert,
    permission
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    key: 'store',
    reducer(state) {
      return { ...state };
    }
  })],
  getters
})
